import { useMemo } from 'react'
import { useModal } from '../../../../../hooks/useModal'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { NEW_SEASON_MODAL } from '../../../../../constants/events'
import { newSeasonModal } from '../../../../../constants/copyright-modals'
import { useOnboarding } from '../../../../../redux/reducer/content'

export default function useNewSeasonModal() {
  const { closeModal } = useModal()
  const { title, description, img, button } = newSeasonModal
  const { eventModalsVisible } = useOnboarding()

  const now = new Date()
  const start = new Date('2026-01-27T00:00:00')
  const end = new Date('2026-02-02T23:59:59')
  const isPromoPeriod = now >= start && now <= end

  return useMemo(
    () =>
      eventModalsVisible &&
      isPromoPeriod && {
        id: 'newSeasonModal',
        type: 'universalModal',
        event: NEW_SEASON_MODAL,
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img,
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: title,
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: description,
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: button,
                        onClick: () => closeModal('all'),
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      },
    [isPromoPeriod, img, title, description, closeModal, eventModalsVisible],
  )
}
